import React, { useState } from 'react';
import { Country, State } from 'country-state-city';
import Accordion from '../../../Accordion/Accordion';
import styles from './Confirmation.module.css';

const Confirmation = ({ formData, addOns, users, onSubmit, goToStep, isSubmitting }) => {
  const [confirmed, setConfirmed] = useState(false);

  const formatUserType = (userType) => {
    const roles = [];
    // state shape uses snake_case flags inside user_type
    if (userType?.is_manager) roles.push('Manager');
    if (userType?.is_on_call_provider) roles.push('On-Call Provider');
    return roles.join(', ');
  };

  const formatCountry = (isoCode) => {
    return Country.getCountryByCode(isoCode)?.name || isoCode;
  };

  const formatState = (countryCode, stateCode) => {
    return State.getStateByCodeAndCountry(stateCode, countryCode)?.name || stateCode;
  };

  const getStateLabel = () => {
    if (formData.country === 'CA') return 'Province';
    return 'State';
  };

  const getZipLabel = () => {
    if (formData.country === 'US') return 'Zip Code';
    return 'Postal Code';
  };

  return (
    <>
      <h2 className={styles.stepTitle}>Submit Registration</h2>
      <div className={styles.formContent}>
        <div className={styles.accordionGroup}>
          <Accordion title="Customer Information" defaultOpen={true} onEdit={() => goToStep(1)}>
            <ul className={styles.lineItemList}>
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>Name</span>
                <span className={styles.lineItemDetails}>
                  {(formData.first_name || '')} {(formData.last_name || '')}
                </span>
              </li>
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>Organization / Practice Name</span>
                <span className={styles.lineItemDetails}>{formData.org_name || 'N/A'}</span>
              </li>
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>Address</span>
                <span className={styles.lineItemDetails}>{formData.address}</span>
              </li>
              {formData.address_2 && (
                <li className={styles.lineItem}>
                  <span className={styles.lineItemName}>Address Line 2</span>
                  <span className={styles.lineItemDetails}>{formData.address_2}</span>
                </li>
              )}
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>Country</span>
                <span className={styles.lineItemDetails}>{formatCountry(formData.country)}</span>
              </li>
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>City</span>
                <span className={styles.lineItemDetails}>{formData.city}</span>
              </li>
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>{getStateLabel()}</span>
                <span className={styles.lineItemDetails}>{formatState(formData.country, formData.state)}</span>
              </li>
              <li className={styles.lineItem}>
                <span className={styles.lineItemName}>{getZipLabel()}</span>
                <span className={styles.lineItemDetails}>{formData.zip}</span>
              </li>
            </ul>
          </Accordion>

          <Accordion title="Added Users" defaultOpen={true} onEdit={() => goToStep(2)}>
            {users.length === 0 ? (
              <div className={styles.noLineItems}>No users added.</div>
            ) : (
              <ul className={styles.lineItemList}>
                {users.map((user, idx) => (
                  <li key={user.id || idx} className={styles.lineItem}>
                    <span className={styles.lineItemName}>
                      {(user.first_name || '')} {(user.last_name || '')}
                    </span>
                    <span className={styles.lineItemDetails}>
                      {formatUserType(user.user_type)}
                    </span>
                  </li>
                ))}
                <li className={styles.lineItem}>
                  <span className={styles.lineItemName}></span>
                  <span className={styles.lineItemDetails}>
                      <b>Total Users:</b> {users.length}
                  </span>
                </li>
              </ul>
            )}
          </Accordion>

          {/* <Accordion title="Selections" onEdit={() => goToStep(5)}>
            {products.length === 0 ? (
              <div className={styles.noLineItems}>No addons selected.</div>
            ) : (
              <ul className={styles.lineItemList}>
                {products.map((prod, idx) => (
                  <li key={prod.id || idx} className={styles.lineItem}>
                    <span className={styles.lineItemName}>{prod.name}</span>
                    <span className={styles.lineItemDetails}>
                      ${(Number(prod.quantity) * Number(prod.cost)).toFixed(2)}
                    </span>
                  </li>
                ))}
                { wantsEmr && (
                  <li className={styles.lineItem}>
                    <span className={styles.lineItemName}>EMR Integration</span>
                    <span className={styles.lineItemDetails}>
                        {emrType}
                    </span>
                  </li>
                )}
                <li className={styles.lineItem}>
                    <span className={styles.lineItemName}></span>
                    <span className={styles.lineItemDetails}>
                        <b>Grand Total:</b> ${products.reduce((total, prod) => total + Number(prod.quantity) * Number(prod.cost), 0).toFixed(2)}
                    </span>
                  </li>
              </ul>
            )}
          </Accordion>

          <Accordion title="Payment Information" onEdit={() => goToStep(4)}>
            <ul className={styles.lineItemList}>
              <li className={styles.lineItem}>
                  <span className={styles.lineItemName}>Payment information is securely stored.</span>
                  <span className={styles.lineItemDetails}></span>
              </li>
            </ul>
          </Accordion> */}

          <div style={{ marginBottom: '20px' }}>
            <label style={{ cursor: 'pointer' }}>
              <input type="checkbox" checked={confirmed} onChange={() => setConfirmed(!confirmed)} style={{ marginRight: '8px' }} />
              I have confirmed all provided information is correct
            </label>
          </div>
          <div>
            <button className={styles.submitButton} onClick={onSubmit} disabled={!confirmed || isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Confirmation;
